<script>
import TableColumn from 'element-ui/lib/table-column';

export default TableColumn;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/table-column.css';
</style>
